exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".sidebar-page{position:absolute;top:0;left:0;bottom:0;right:0;-webkit-transition:all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;-o-transition:all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;transition:all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;width:100%}.sidebar-page.open{left:306px;width:calc(100% - 306px)}@media (max-width: 700px){.sidebar-page.open{width:100%}}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./node_modules/sass-loader/dist/cjs.js!./src/components/Sidebar/components/SidebarPage/style.scss
// module id = 1280
// module chunks = 0